module.exports = __webpack_public_path__ + "static/media/bckg2.24935e8a.png";